import { render, staticRenderFns } from "./UsersManager.vue?vue&type=template&id=0bdb2d8d"
import script from "./UsersManager.vue?vue&type=script&lang=js"
export * from "./UsersManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports